import { db, ordenReplay, type LocalEvent } from '../db/dexie.js';

/** How many of the records the server numbered «Bitácora» reads while nothing is asked of it. */
export const ULTIMOS_DE_LA_BITACORA = 1500;

/**
 * The log as «Bitácora» lists it, the latest first: what this device recorded and has not sent yet
 * on top (the serverSeq index only holds what the server numbered), then what the server numbered —
 * the latest `ultimos` while nothing is asked of it, all of it once something is (`todo`).
 */
export async function leerBitacora(todo: boolean, ultimos = ULTIMOS_DE_LA_BITACORA): Promise<LocalEvent[]> {
  const numerados = db.eventos.orderBy('serverSeq').reverse();
  const [sinNumero, conNumero] = await Promise.all([
    db.eventos
      .where('estado')
      .notEqual('confirmado')
      .filter((e) => e.serverSeq == null)
      .toArray(),
    (todo ? numerados : numerados.limit(ultimos)).toArray(),
  ]);
  return [...sinNumero.sort(ordenReplay).reverse(), ...conNumero];
}

/**
 * Whether a read of the latest stopped at them, with more of the log behind: «Ver más» there reads
 * the rest, instead of the list ending at the fifteen hundredth as if the shop began there.
 */
export function quedanMasViejos(leidos: readonly LocalEvent[], ultimos = ULTIMOS_DE_LA_BITACORA): boolean {
  return leidos.filter((e) => e.serverSeq != null).length >= ultimos;
}
